import styled from "styled-components";
import PaginatedTable from "../../Componentes/Utils/PaginatedTable";
import { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";
import { useModal } from "../../contexts/ModalContext";
import { RiNotification3Fill } from "react-icons/ri";
import ModalSelecionarNf from "./ModalSelecionarNf";
import { useToast } from "../../contexts/ToastContext";
import { useRegisterControladoriaPageActions } from "./layout";

const Container = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`;

const FiltersBar = styled.form`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;
    padding: 12px 15px 4px;
    flex-shrink: 0;
`;

const FilterGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const FilterLabel = styled.label`
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--ctrl-label, #94a3b8);
`;

const FilterInput = styled.input`
    height: 34px;
    padding: 0 10px;
    border: 1.2px solid var(--ctrl-border, #d3d3d3);
    border-radius: 4px;
    font-size: 13px;
    min-width: 160px;
`;

const FilterSelect = styled.select`
    height: 34px;
    padding: 0 8px;
    border: 1.2px solid var(--ctrl-border, #d3d3d3);
    border-radius: 4px;
    font-size: 13px;
    background-color: var(--ctrl-surface, #fff);
    min-width: 180px;
    cursor: pointer;
`;

const AplicarBtn = styled.button`
    height: 34px;
    padding: 0 18px;
    border: none;
    border-radius: 4px;
    background-color: #2563eb;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;

    &:hover {
        background-color: #1d4ed8;
    }
`;

const LimparBtn = styled.button`
    height: 34px;
    padding: 0 14px;
    border: 1.2px solid var(--ctrl-border, #d3d3d3);
    border-radius: 4px;
    background-color: transparent;
    font-size: 13px;
    color: #475569;
    cursor: pointer;

    &:hover {
        background-color: var(--ctrl-surface-muted, #f0f0f0);
    }
`;

const TotaisBar = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    padding: 8px 15px 12px;
    flex-shrink: 0;
`;

const TotalCard = styled.div`
    flex: 1;
    min-width: 150px;
    border: 1.2px solid var(--ctrl-border-soft, #e2e8f0);
    border-left: 4px solid ${(props) => props.$accent || "#cbd5e1"};
    border-radius: 8px;
    padding: 8px 14px;
    background-color: var(--ctrl-surface, #fff);
`;

const TotalLabel = styled.span`
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
`;

const TotalValue = styled.span`
    font-size: 22px;
    font-weight: 700;
    color: ${(props) => props.$color || "var(--ctrl-text, #1f2937)"};
`;

const Body = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: var(--ctrl-surface, #fff);
    margin-top: 5px;
    border-radius: 8px;
    border: 1.2px solid var(--ctrl-border, #d3d3d3);
    box-sizing: border-box;
`;

const LinhaTabela = styled.tr`
    background-color: ${(props) => (props.$destaque ? "#ecfdf5" : "transparent")};
    cursor: ${(props) => (props.$clicavel ? "pointer" : "default")};

    &:hover {
        background-color: ${(props) => (props.$clicavel ? "#d1fae5" : props.$destaque ? "#ecfdf5" : "transparent")};
    }
`;

const NfDisponivelBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    background-color: #d1fae5;
    color: #065f46;

    & svg {
        width: 14px;
        height: 14px;
    }
`;

const SemNf = styled.span`
    color: #9ca3af;
    font-size: 13px;
`;

const ParcialBadge = styled.span`
    display: inline-block;
    margin-left: 8px;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 700;
    background-color: #fef9c3;
    color: #854d0e;
`;

const FILTROS_INICIAIS = {
    numPedido: "",
    filial: "",
    codFornecedor: "",
    usuario: "",
    disponibilidade: "todos",
};

const NfsPendentes = () => {
    const api = useApi();
    const { notifyError } = useToast();
    const { isModalOpen, openModal, closeModal } = useModal();

    const [pagina, setPagina] = useState(1);
    const [loading, setLoading] = useState(false);
    const [refreshing, setRefreshing] = useState(false);

    const [dados, setDados] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [periodo, setPeriodo] = useState({ inicio: "", fim: "" });
    const [totais, setTotais] = useState({ total: 0, com_nf_disponivel: 0, sem_nf_disponivel: 0 });

    const [filtros, setFiltros] = useState(FILTROS_INICIAIS);
    const [filtrosAplicados, setFiltrosAplicados] = useState(FILTROS_INICIAIS);

    const [detalhes, setDetalhes] = useState(null);
    const [loadingDetalhes, setLoadingDetalhes] = useState(false);

    const fetchDados = async (page = pagina, f = filtrosAplicados) => {
        setLoading(true);

        try {
            const params = new URLSearchParams();
            params.append("page", page);
            params.append("limit", 50);
            params.append("apenas_sem_nf", "1");

            if (f.numPedido) params.append("num_pedido", f.numPedido);
            if (f.filial) params.append("filial", f.filial);
            if (f.codFornecedor) params.append("cod_fornecedor", f.codFornecedor);
            if (f.usuario) params.append("usuario", f.usuario);
            if (f.disponibilidade && f.disponibilidade !== "todos") {
                params.append("disponibilidade", f.disponibilidade);
            }

            const { data } = await api.get(
                `Painel/API/Controladoria/PedidosCompra/VinculoNf/index.php?${params.toString()}`
            );

            setDados(data.data || []);
            setTotalItems(data.quantidade || 0);
            setTotalPages(data.total_pages || 0);
            setTotais(data.totais || { total: 0, com_nf_disponivel: 0, sem_nf_disponivel: 0 });
            setPeriodo({
                inicio: data.periodo_inicio || "",
                fim: data.periodo_fim || "",
            });
        } catch (e) {
            notifyError(e?.response?.data?.message || "Erro ao carregar NFs pendentes.");
        } finally {
            setLoading(false);
        }
    };

    // Os filtros só são buscados quando "filtrosAplicados" muda (botão Aplicar) ou ao trocar de página.
    useEffect(() => {
        fetchDados(pagina, filtrosAplicados);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagina, filtrosAplicados]);

    const refreshData = async () => {
        if (refreshing) return;

        setRefreshing(true);
        await fetchDados(pagina, filtrosAplicados);
        setRefreshing(false);
    };

    useRegisterControladoriaPageActions({
        onRefresh: refreshData,
        refreshing,
    });

    const atualizarFiltro = (campo, valor) => {
        setFiltros((atual) => ({ ...atual, [campo]: valor }));
    };

    const aplicarFiltros = (e) => {
        if (e) e.preventDefault();
        setFiltrosAplicados(filtros);
        setPagina(1);
    };

    const limparFiltros = () => {
        setFiltros(FILTROS_INICIAIS);
        setFiltrosAplicados(FILTROS_INICIAIS);
        setPagina(1);
    };

    const temFiltro =
        filtros.numPedido !== "" ||
        filtros.filial !== "" ||
        filtros.codFornecedor !== "" ||
        filtros.usuario !== "" ||
        filtros.disponibilidade !== "todos";

    const abrirNfsDisponiveis = async (item) => {
        if (!item.TEM_NF_DISPONIVEL) return;

        setDetalhes(null);
        setLoadingDetalhes(true);
        openModal("controladoria-selecionar-nf");

        try {
            const params = new URLSearchParams();
            params.append("filial", item.FILIAL);
            params.append("num_pedido", item.NUM_PEDIDO);

            const { data } = await api.get(
                `Painel/API/Controladoria/PedidosCompra/VinculoNf/Detalhes/index.php?${params.toString()}`
            );

            setDetalhes(data);
        } catch (e) {
            notifyError(e?.response?.data?.message || "Erro ao carregar detalhes do pedido.");
        } finally {
            setLoadingDetalhes(false);
        }
    };

    return (
        <Container>
            <FiltersBar onSubmit={aplicarFiltros}>
                <FilterGroup>
                    <FilterLabel htmlFor="filtro-pc">Número do PC</FilterLabel>
                    <FilterInput
                        id="filtro-pc"
                        type="text"
                        placeholder="Ex: 046064"
                        value={filtros.numPedido}
                        onChange={(e) => atualizarFiltro("numPedido", e.target.value)}
                    />
                </FilterGroup>
                <FilterGroup>
                    <FilterLabel htmlFor="filtro-filial">Filial</FilterLabel>
                    <FilterInput
                        id="filtro-filial"
                        type="text"
                        placeholder="Ex: 01010002"
                        value={filtros.filial}
                        onChange={(e) => atualizarFiltro("filial", e.target.value)}
                    />
                </FilterGroup>
                <FilterGroup>
                    <FilterLabel htmlFor="filtro-fornecedor">Cód. Fornecedor</FilterLabel>
                    <FilterInput
                        id="filtro-fornecedor"
                        type="text"
                        placeholder="Ex: 000123"
                        value={filtros.codFornecedor}
                        onChange={(e) => atualizarFiltro("codFornecedor", e.target.value)}
                    />
                </FilterGroup>
                <FilterGroup>
                    <FilterLabel htmlFor="filtro-usuario">Usuário</FilterLabel>
                    <FilterInput
                        id="filtro-usuario"
                        type="text"
                        placeholder="Nome do usuário"
                        value={filtros.usuario}
                        onChange={(e) => atualizarFiltro("usuario", e.target.value)}
                    />
                </FilterGroup>
                <FilterGroup>
                    <FilterLabel htmlFor="filtro-disp">Disponibilidade</FilterLabel>
                    <FilterSelect
                        id="filtro-disp"
                        value={filtros.disponibilidade}
                        onChange={(e) => atualizarFiltro("disponibilidade", e.target.value)}
                    >
                        <option value="todos">Todas</option>
                        <option value="disponivel">NF disponível</option>
                        <option value="pendente">Sem NF (pendente)</option>
                    </FilterSelect>
                </FilterGroup>
                <FilterGroup>
                    <AplicarBtn type="submit">Aplicar filtros</AplicarBtn>
                </FilterGroup>
                {temFiltro && (
                    <FilterGroup>
                        <LimparBtn type="button" onClick={limparFiltros}>
                            Limpar filtros
                        </LimparBtn>
                    </FilterGroup>
                )}
            </FiltersBar>

            <TotaisBar>
                <TotalCard $accent="#94a3b8">
                    <TotalLabel>Total de pedidos</TotalLabel>
                    <TotalValue>{totais.total}</TotalValue>
                </TotalCard>
                <TotalCard $accent="#22c55e">
                    <TotalLabel>Com NF disponível</TotalLabel>
                    <TotalValue $color="#15803d">{totais.com_nf_disponivel}</TotalValue>
                </TotalCard>
                <TotalCard $accent="#f59e0b">
                    <TotalLabel>Aguardando NF</TotalLabel>
                    <TotalValue $color="#b45309">{totais.sem_nf_disponivel}</TotalValue>
                </TotalCard>
            </TotaisBar>

            <Body>
                <PaginatedTable
                    pagina={pagina}
                    setPagina={setPagina}
                    loading={loading}
                    colunas={6}
                    totalItems={totalItems}
                    totalPages={totalPages}
                    mobileCards={dados.map((item) => ({
                        key: `${item.FILIAL}-${item.NUM_PEDIDO}-${item.DT_EMISSAO}`,
                        title: `PC ${item.NUM_PEDIDO} · Filial ${item.FILIAL}${item.STATUS_PC === "PARCIAL" ? " (Parcial)" : ""}`,
                        meta: `${item.DT_EMISSAO || "—"} · ${item.FORNECEDOR || "Sem fornecedor"} · ${
                            item.TEM_NF_DISPONIVEL
                                ? item.DT_NF_DISPONIVEL
                                    ? `NF disponível (${item.DT_NF_DISPONIVEL})`
                                    : "NF disponível"
                                : "Aguardando NF"
                        }`,
                        onClick: () => abrirNfsDisponiveis(item),
                    }))}
                    thead={
                        <tr>
                            <th>FILIAL</th>
                            <th>NÚMERO PEDIDO</th>
                            <th>DATA EMISSÃO</th>
                            <th>FORNECEDOR</th>
                            <th>USUÁRIO</th>
                            <th>NF DISPONÍVEL</th>
                        </tr>
                    }
                >
                    <tbody>
                        {dados.map((item) => (
                            <LinhaTabela
                                key={`${item.FILIAL}-${item.NUM_PEDIDO}-${item.DT_EMISSAO}`}
                                $destaque={item.TEM_NF_DISPONIVEL}
                                $clicavel={item.TEM_NF_DISPONIVEL}
                                onClick={() => abrirNfsDisponiveis(item)}
                            >
                                <td>{item.FILIAL}</td>
                                <td>
                                    {item.NUM_PEDIDO}
                                    {item.STATUS_PC === "PARCIAL" && <ParcialBadge>Parcial</ParcialBadge>}
                                </td>
                                <td>{item.DT_EMISSAO}</td>
                                <td>{item.FORNECEDOR || " - "}</td>
                                <td>{item.USUARIO || " - "}</td>
                                <td>
                                    {item.TEM_NF_DISPONIVEL ? (
                                        <NfDisponivelBadge
                                            title={
                                                item.DT_NF_DISPONIVEL
                                                    ? `NF emitida em ${item.DT_NF_DISPONIVEL}`
                                                    : "NF disponível para vínculo"
                                            }
                                        >
                                            <RiNotification3Fill />
                                            NF disponível
                                            {item.DT_NF_DISPONIVEL ? ` (${item.DT_NF_DISPONIVEL})` : ""}
                                        </NfDisponivelBadge>
                                    ) : (
                                        <SemNf>Nenhuma NF encontrada</SemNf>
                                    )}
                                </td>
                            </LinhaTabela>
                        ))}
                    </tbody>
                </PaginatedTable>
            </Body>

            {isModalOpen("controladoria-selecionar-nf") && (
                <ModalSelecionarNf
                    fecharModal={closeModal}
                    detalhes={detalhes}
                    loading={loadingDetalhes}
                    onVinculado={() => fetchDados(pagina, filtrosAplicados)}
                />
            )}
        </Container>
    );
};

export default NfsPendentes;
